import React, {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {PageHeader} from "../components/layout/PageHeader";
import {Button, Col, Form, Input, Pagination, Row, Spin} from "antd";
import {useHistory} from "react-router-dom";
import {BusinessSectorCreateEditDto, BusinessSectorDto, BusinessSectorListItemDto} from "../generated-api";
import {PieChart, PlusCircle} from "react-feather";
import {DEFAULT_PAGE_SIZE} from "../constants";
import {BackButton} from "../components/layout/BackButton";
import {
    createBusinessSector,
    getBusinessSectors,
    useBusinessSectorCreate,
    useBusinessSectors
} from "../hooks/businessSectors";

const pageSize = DEFAULT_PAGE_SIZE;

export function BusinessSectorsPage() {
    const {t} = useTranslation();
    const history = useHistory();
    useEffect(() => {
        getBusinessSectors().then().catch(console.error);
    }, [true]);
    const businessSectorsResponse = useBusinessSectors();
    const businessSectors = businessSectorsResponse.data || [];
    const businessSectorsCreateResponse = useBusinessSectorCreate();
    const [page, setPage] = useState(1);
    const [addFormCollapsed, setAddFormCollapsed] = useState(true);
    const [form] = Form.useForm();

    const validateMessages = {
        required: t('error.required'),
        string: {
            max: t('error.string.max')
        }
    };

    const onFinish = (values: BusinessSectorCreateEditDto): void => {
        createBusinessSector(values).then((businessSector: BusinessSectorDto) => {
            history.push('/businessSectors/' + businessSector.id);
        }).catch(console.error);
    };

    const processed = [];
    for (let i = (page - 1) * pageSize; i < page * pageSize; i++) {
        businessSectors[i] && processed.push(businessSectors[i]);
    }

    return (
        <Spin spinning={businessSectorsResponse.loading}>
            <PageHeader/>
            <div className={'top-block accent6-background'}>
                <div className={'flex-row'}>
                    <h1 className={'h1 flex-auto'}><BackButton/><PieChart/>{t('businessSectors.title')}</h1>
                    <a href={'/businessSectors/add'}
                       className={'title-icon-button ' + (addFormCollapsed ? '' : 'toggle')}
                       onClick={event => {
                           event.preventDefault();
                           setAddFormCollapsed(!addFormCollapsed);
                           form.resetFields();
                       }}>
                        <PlusCircle className={addFormCollapsed ? '' : 'rotate45'}/>
                    </a>
                </div>
                <Spin spinning={businessSectorsCreateResponse.loading}>
                    <Form form={form} name="businessSector" onFinish={onFinish} validateMessages={validateMessages}
                          autoComplete={'off'} className={addFormCollapsed ? 'collapsed' : 'expanded'}
                          validateTrigger={'onSubmit'}>
                        <Row className={'row-offset'}>
                            <Col span={24} md={12} xl={8}>
                                <Form.Item name={'name'} rules={[{required: true}, {max: 512}]}>
                                    <Input placeholder={t('businessSector.name')}/>
                                </Form.Item>
                            </Col>
                        </Row>
                        <Form.Item className={'no-margin'}>
                            <Button type="primary" className={'white-background text-default w-100'} htmlType="submit">
                                {t('businessSectors.add')}
                            </Button>
                        </Form.Item>
                    </Form>
                </Spin>
            </div>
            <div className={'subpage-content'}>
                {processed.map((businessSector: BusinessSectorListItemDto, index: number) =>
                    <div key={index} className={'card accent6-background'}>
                        <a href={'/businessSectors/' + businessSector.id} onClick={event => {
                            event.preventDefault();
                            history.push('/businessSectors/' + businessSector.id);
                        }}>
                            <div className={'card-header flex-row no-border'}>
                                {businessSector.name}
                            </div>
                        </a>
                    </div>
                )}
                {!processed.length && <div className={'no-data'}>{t('general.noData')}</div>}
                {businessSectors.length > pageSize &&
                <Pagination onChange={setPage} pageSize={pageSize} total={businessSectors.length} current={page}
                            defaultCurrent={page}/>
                }
            </div>
        </Spin>
    )
}
